/**
 * Sprint 2 navigation helpers
 * Sticky header + search enhancements.
 * Mobile hamburger bridge lives in gwh-navigation.js.
 */

class GwhSprint2Nav {
  constructor() {
    this.initStickyHeader();
    this.initSearchEnhancements();
  }

  initStickyHeader() {
    /* Horizon handles sticky via enable_sticky_header.
       Do not attach scroll-hide on #header-group — it sets pointer-events:none and kills menu hover. */
  }

  initSearchEnhancements() {
    const storageKey = 'gwh-recent-searches';
    const searchInput = document.querySelector('.predictive-search-form__input, [data-search-input]');

    if (!searchInput) return;

    const saveSearch = (query) => {
      const trimmed = query.trim();
      if (!trimmed) return;

      let recent = [];
      try {
        recent = JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch {
        recent = [];
      }

      recent = [trimmed, ...recent.filter((item) => item !== trimmed)].slice(0, 5);
      localStorage.setItem(storageKey, JSON.stringify(recent));
    };

    searchInput.closest('form')?.addEventListener('submit', () => {
      saveSearch(searchInput.value);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new GwhSprint2Nav();
});
